import A from 'actions/fsdo/fsdoContactActions';

export const 
fsdoSetExistingEmail = email => ({ type: A.SET_EXISTING_EMAIL, payload: email}),
fsdoMarkFieldErrorCode = (code, field) => ({ type: A.FSDO_SET_REQUEST_ERROR_MSG, payload: { code, field }}),
fsdoToggleErrorMsg = () => ({ type: A.FSDO_TOGGLE_ERROR_MSG });
